export default __webpack_public_path__ + "static/media/ic_dai_24.c08c4f94.svg";